import { ApiError } from './ApiError';

export class BadRequestError extends ApiError {
  constructor(message: string, errors: unknown[] = []) {
    super(400, message, errors);
    this.name = 'BadRequestError';
  }
}
